module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Drag-4c961d64d93ab3ffbdcd678a0052264d.png";